import { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';
import { makeSelectVirtualizedTableColumnOptionText } from 'services/virtualizedTable/selectors';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    optionText?: string | undefined;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableColumnOptionTextComponent = (
    props: Props
): VirtualizedTableItemValue | null => {
    const { optionText } = props;

    if (optionText) {
        return optionText;
    }

    return null;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    optionText: makeSelectVirtualizedTableColumnOptionText()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableColumnOptionTextComponent)
);
